import {
  startAuthentication,
  startRegistration,
  type PublicKeyCredentialCreationOptionsJSON,
  type PublicKeyCredentialRequestOptionsJSON,
} from "@simplewebauthn/browser";
import { ApiError } from "./api";

async function getJson<T>(path: string): Promise<T> {
  const res = await fetch(path);
  if (!res.ok) throw new ApiError(res.status, res.statusText);
  return (await res.json()) as T;
}

async function post(path: string, body: unknown): Promise<void> {
  const res = await fetch(path, {
    method: "POST",
    headers: { "content-type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new ApiError(res.status, res.statusText);
}

export async function hasPasskey(): Promise<boolean> {
  try {
    const { hasPasskey } = await getJson<{ hasPasskey: boolean }>("/api/passkey/exists");
    return hasPasskey;
  } catch {
    return false;
  }
}

/** Requires an active session. Face ID / Touch ID prompt happens here. */
export async function registerPasskey(): Promise<void> {
  const options = await getJson<PublicKeyCredentialCreationOptionsJSON>(
    "/api/passkey/register-options",
  );
  const response = await startRegistration({ optionsJSON: options });
  await post("/api/passkey/register", { response });
}

/** Public: authenticates and sets the session cookie. */
export async function loginWithPasskey(): Promise<void> {
  const options = await getJson<PublicKeyCredentialRequestOptionsJSON>(
    "/api/passkey/login-options",
  );
  const response = await startAuthentication({ optionsJSON: options });
  await post("/api/passkey/login", { response });
}
